import axios from "axios";
import { BACKEND_BASEURL } from "../../../db/baseUrl";
export const API_INVENTORY_ADJUST = `${BACKEND_BASEURL}api/inventoryAdjusts/`;

const inventoryAdjust = async (inventoryAdjustData) => {
  const response = await axios.post(
    API_INVENTORY_ADJUST + "inventoryAdjust",
    inventoryAdjustData
  );
  return response.data;
};

const getInventoryAdjusts = async () => {
  const response = await axios.get(
    API_INVENTORY_ADJUST + "getInventoryAdjusts"
  );
  return response.data;
};

const InventoryAdjustServices = {
  inventoryAdjust,
  getInventoryAdjusts,
};
export default InventoryAdjustServices;
